import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { parseISO, format } from 'date-fns';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOrgaos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'orgaos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOrgao({ payload }) {
  try {
    const { idorgao, params } = payload;

    yield call(api.delete, `orgaos/${idorgao}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { orgao, params } = payload;

    yield call(api.post, 'orgaos', orgao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/cadorgao');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idorgao } = payload;

    const { data } = yield call(api.get, `orgaos/${idorgao}`);

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { orgao, params } = payload;

    yield call(api.put, 'orgaos', orgao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/cadorgao');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'orgaos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    const itemsMod = items.map((item) => ({
      ...item,
      orga_data_publicacao_contrato: item.orga_data_publicacao_contrato
        ? format(
            parseISO(item.orga_data_publicacao_contrato),
            'dd/MM/yyyy HH:mm:ss'
          )
        : '',
      orga_data_ultimo_periodo: item.orga_data_ultimo_periodo
        ? format(parseISO(item.orga_data_ultimo_periodo), 'dd/MM/yyyy HH:mm:ss')
        : '',
    }));

    yield put(
      successInRequest(itemsMod, page, pageSize, totalCount, totalPages)
    );
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@orgao/ORGAOS_IN_REQUEST', requestOrgaos),
  takeLatest('@orgao/DELETE_ORGAO', deleteOrgao),
  takeLatest('@orgao/SUCCESS_REMOVE', requestOrgaos),
  takeLatest('@orgao/STORE_ORGAO', store),
  takeLatest('@orgao/FIND_ORGAO', find),
  takeLatest('@orgao/UPDATE_ORGAO', update),
  takeLatest('@orgao/RECORD_FILTERING', applyedFilters),
]);
